/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { ConfirmationCssClasses, NoticeStatusTitles } from "../../../../../../../_helpers/Helpers";

export const StatusColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      ConfirmationCssClasses[row.isSent]
    } label-inline`}
  >
    {NoticeStatusTitles[row.isSent]}
  </span>
);